module.exports = __webpack_public_path__ + "static/ovolo-6c95608877128b72ea0a4979014411ba.svg";